import 'svelte/internal/disclose-version';

RestaurantDetail[$.FILENAME] = 'src/pages/RestaurantDetail.svelte';

import * as $ from 'svelte/internal/client';
import api from "../lib/api.js";
import Stars from "../components/Stars.svelte";
import FavoriteButton from "../components/FavoriteButton.svelte";
import ReviewCard from "../components/ReviewCard.svelte";
import ReviewForm from "../components/ReviewForm.svelte";
import RestaurantCard from "../components/RestaurantCard.svelte";
import EmptyState from "../components/EmptyState.svelte";
import { route } from "../lib/router.svelte.js";
import { rememberView } from "../lib/prefs.svelte.js";
import { session } from "../lib/session.svelte.js";
import { formatLocation, priceLabel, relativeTime } from "../lib/format.js";
import { searchUrl } from "../lib/routes.js";
import { toastError } from "../lib/toast.svelte.js";

var root = $.add_locations($.from_html(`<div class="loading-shell svelte-1694xcs" aria-hidden="true"></div>`), RestaurantDetail[$.FILENAME], [[144, 2]]);
var root_1 = $.add_locations($.from_html(`<img alt="" class="svelte-1694xcs"/>`), RestaurantDetail[$.FILENAME], [[149, 8]]);
var root_2 = $.add_locations($.from_html(`<div class="banner-fallback svelte-1694xcs"> </div>`), RestaurantDetail[$.FILENAME], [[151, 8]]);
var root_3 = $.add_locations($.from_html(`<!> <span class="split svelte-1694xcs"><!></span>`, 1), RestaurantDetail[$.FILENAME], [[166, 12]]);
var root_4 = $.add_locations($.from_html(`<span class="split muted svelte-1694xcs">No ratings yet</span>`), RestaurantDetail[$.FILENAME], [[176, 12]]);
var root_5 = $.add_locations($.from_html(`<a class="button ghost svelte-1694xcs">Call</a>`), RestaurantDetail[$.FILENAME], [[184, 21]]);
var root_6 = $.add_locations($.from_html(`<p class="lede svelte-1694xcs"> </p>`), RestaurantDetail[$.FILENAME], [[190, 27]]);
var root_7 = $.add_locations($.from_html(`<li class="svelte-1694xcs"> </li>`), RestaurantDetail[$.FILENAME], [[194, 39]]);
var root_8 = $.add_locations($.from_html(`<ul class="tags svelte-1694xcs"></ul>`), RestaurantDetail[$.FILENAME], [[193, 10]]);
var root_9 = $.add_locations($.from_html(`<span class="credit svelte-1694xcs"> </span>`), RestaurantDetail[$.FILENAME], [[212, 20]]);
var root_10 = $.add_locations($.from_html(`<button class="shot svelte-1694xcs" type="button"><img alt="" loading="lazy" decoding="async" class="svelte-1694xcs"/> <!></button>`), RestaurantDetail[$.FILENAME], [[203, 16, [[209, 18]]]]);
var root_11 = $.add_locations($.from_html(`<section class="gallery svelte-1694xcs"><h2 class="svelte-1694xcs">Photos</h2> <div class="grid svelte-1694xcs"></div></section>`), RestaurantDetail[$.FILENAME], [[199, 10, [[200, 12], [201, 12]]]]);
var root_12 = $.add_locations($.from_html(`<p class="muted svelte-1694xcs">Be the first to say something — even a sentence helps.</p>`), RestaurantDetail[$.FILENAME], [[223, 12]]);

var root_13 = $.add_locations($.from_html(`<blockquote class="svelte-1694xcs"><p class="svelte-1694xcs"> </p> <footer class="svelte-1694xcs"><span aria-hidden="true" class="svelte-1694xcs"> </span> <cite class="svelte-1694xcs"> </cite> <a target="_blank" rel="noopener noreferrer nofollow" class="svelte-1694xcs"> </a></footer></blockquote>`), RestaurantDetail[$.FILENAME], [
	[
		262,
		18,
		[[263, 20], [264, 20, [[265, 22], [266, 22], [267, 22]]]]
	]
]);

var root_14 = $.add_locations($.from_html(`<article class="source svelte-1694xcs"><header class="svelte-1694xcs"><div><span class="stars svelte-1694xcs" aria-hidden="true"> </span> <strong class="svelte-1694xcs"> </strong> <span class="muted svelte-1694xcs"> </span></div> <a target="_blank" rel="noopener noreferrer nofollow" class="svelte-1694xcs"> </a></header> <!> <p class="asof svelte-1694xcs"> </p></article>`), RestaurantDetail[$.FILENAME], [
	[
		246,
		14,
		[
			[
				247,
				16,
				[[248, 18, [[249, 20], [250, 20], [251, 20]]], [256, 18]]
			],
			[272, 16]
		]
	]
]);

var root_15 = $.add_locations($.from_html(`<section class="elsewhere svelte-1694xcs"><h2 class="svelte-1694xcs">Elsewhere on the web</h2> <!></section>`), RestaurantDetail[$.FILENAME], [[243, 10, [[244, 12]]]]);
var root_16 = $.add_locations($.from_html(`<iframe class="map svelte-1694xcs" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`), RestaurantDetail[$.FILENAME], [[283, 12]]);
var root_17 = $.add_locations($.from_html(`<dt class="svelte-1694xcs">Hours</dt><dd class="svelte-1694xcs"> </dd>`, 1), RestaurantDetail[$.FILENAME], [[296, 25], [296, 39]]);
var root_18 = $.add_locations($.from_html(`<dt class="svelte-1694xcs">Phone</dt><dd class="svelte-1694xcs"><a class="svelte-1694xcs"> </a></dd>`, 1), RestaurantDetail[$.FILENAME], [[297, 25], [297, 39, [[297, 43]]]]);
var root_19 = $.add_locations($.from_html(`<dt class="svelte-1694xcs">Website</dt><dd class="svelte-1694xcs"><a target="_blank" rel="noopener noreferrer" class="svelte-1694xcs">Visit site</a></dd>`, 1), RestaurantDetail[$.FILENAME], [[298, 27], [298, 43, [[298, 47]]]]);
var root_20 = $.add_locations($.from_html(`<section class="similar svelte-1694xcs"><h2 class="svelte-1694xcs">You might also like</h2> <div class="grid svelte-1694xcs"></div></section>`), RestaurantDetail[$.FILENAME], [[306, 6, [[307, 8], [308, 8]]]]);
var root_21 = $.add_locations($.from_html(`Photo by <a target="_blank" rel="noopener noreferrer nofollow" class="svelte-1694xcs"> </a>`, 1), RestaurantDetail[$.FILENAME], [[330, 19]]);
var root_22 = $.add_locations($.from_html(`<div class="lightbox svelte-1694xcs" role="dialog" aria-modal="true" aria-label="Photo" tabindex="-1"><img alt="" class="svelte-1694xcs"/> <p class="lightbox-credit svelte-1694xcs"><!> <span class="via svelte-1694xcs"> </span></p> <button class="close svelte-1694xcs" type="button" aria-label="Close">×</button></div>`), RestaurantDetail[$.FILENAME], [[318, 4, [[327, 6], [328, 6, [[334, 8]]], [336, 6]]]]);

var root_23 = $.add_locations($.from_html(`<article><div class="banner svelte-1694xcs"><!></div> <header class="intro svelte-1694xcs"><div class="titles"><p class="crumb svelte-1694xcs"><a class="svelte-1694xcs"> </a> <span aria-hidden="true">·</span> <a class="svelte-1694xcs"> </a></p> <h1 class="svelte-1694xcs"> </h1> <div class="rating-row svelte-1694xcs"><!> <span class="price svelte-1694xcs"> </span></div></div> <div class="cta svelte-1694xcs"><!> <a class="button svelte-1694xcs" target="_blank" rel="noopener noreferrer">Directions</a> <!></div></header> <div class="columns svelte-1694xcs"><div class="main svelte-1694xcs"><!> <!> <!> <section class="reviews svelte-1694xcs"><h2 class="svelte-1694xcs"> </h2> <!></section> <!> <!></div> <aside class="side"><div class="panel svelte-1694xcs"><h3 class="svelte-1694xcs">Find it</h3> <!> <p class="addr svelte-1694xcs"> <br/> </p> <dl class="svelte-1694xcs"><!> <!> <!> <dt class="svelte-1694xcs">Price</dt><dd class="svelte-1694xcs"> </dd></dl></div></aside></div> <!></article> <!>`, 1), RestaurantDetail[$.FILENAME], [
	[
		146,
		2,
		[
			[147, 4],
			[
				155,
				4,
				[
					[
						156,
						6,
						[
							[157, 8, [[158, 10], [159, 10], [160, 10]]],
							[162, 8],
							[163, 8, [[178, 10]]]
						]
					],
					[181, 6, [[183, 8]]]
				]
			],

			[
				188,
				4,
				[
					[189, 6, [[220, 8, [[221, 10]]]]],
					[
						279,
						6,
						[
							[
								280,
								8,
								[
									[281, 10],
									[291, 10, [[292, 23]]],
									[295, 10, [[299, 12], [299, 26]]]
								]
							]
						]
					]
				]
			]
		]
	]
]);

const $$css = {
	hash: 'svelte-1694xcs',
	code: '\n  .loading-shell.svelte-1694xcs {\n    height: 60vh;\n    border-radius: var(--radius-lg);\n    background: var(--card);\n    border: 1px solid var(--line);\n    margin-top: 24px;\n  }\n\n  .banner.svelte-1694xcs {\n    margin-top: 20px;\n    border-radius: var(--radius-lg);\n    overflow: hidden;\n    aspect-ratio: 21 / 8;\n    background: var(--card-soft);\n    border: 1px solid var(--line);\n  }\n  .banner.svelte-1694xcs img:where(.svelte-1694xcs) { width: 100%; height: 100%; object-fit: cover; display: block; }\n  .banner-fallback.svelte-1694xcs {\n    width: 100%; height: 100%;\n    display: grid; place-items: center;\n    font-family: var(--font);\n    font-size: 4rem;\n    color: var(--accent);\n    background: linear-gradient(140deg, var(--accent-soft), var(--mustard-soft));\n  }\n\n  .intro.svelte-1694xcs {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 20px;\n    padding: 22px 0 26px;\n    flex-wrap: wrap;\n  }\n  .crumb.svelte-1694xcs { margin: 0 0 6px; font-size: 0.88rem; color: var(--ink-soft); display: flex; gap: 8px; }\n  .crumb.svelte-1694xcs a:where(.svelte-1694xcs):hover { color: var(--accent); text-decoration: underline; }\n  h1.svelte-1694xcs { font-size: clamp(1.9rem, 4.4vw, 2.7rem); line-height: 1.1; }\n  .rating-row.svelte-1694xcs { display: flex; align-items: center; gap: 14px; margin-top: 10px; }\n  .rating-row.svelte-1694xcs .split:where(.svelte-1694xcs) { font-size: 0.86rem; color: var(--ink-soft); letter-spacing: 0.01em; margin: 0; }\n  .rating-row.svelte-1694xcs .split.muted:where(.svelte-1694xcs) { opacity: 0.75; }\n  .price.svelte-1694xcs { color: var(--sage); font-weight: 700; }\n\n  .cta.svelte-1694xcs { display: flex; align-items: center; gap: 10px; }\n  .button.svelte-1694xcs {\n    background: var(--accent);\n    color: #fff;\n    font-weight: 600;\n    font-size: 0.9rem;\n    padding: 11px 20px;\n    border-radius: var(--radius-pill);\n  }\n  .button.svelte-1694xcs:hover { background: var(--accent-dark); }\n  .button.ghost.svelte-1694xcs {\n    background: var(--card);\n    color: var(--ink);\n    border: 1px solid var(--line-strong);\n  }\n  .button.ghost.svelte-1694xcs:hover { border-color: var(--accent); color: var(--accent); }\n\n  .columns.svelte-1694xcs { display: grid; grid-template-columns: 1fr 300px; gap: 32px; align-items: start; }\n  .main.svelte-1694xcs { display: flex; flex-direction: column; gap: 24px; min-width: 0; }\n\n  .lede.svelte-1694xcs { margin: 0; font-size: 1.06rem; line-height: 1.65; color: var(--ink-soft); }\n\n  .tags.svelte-1694xcs { list-style: none; display: flex; gap: 8px; flex-wrap: wrap; padding: 0; margin: 0; }\n  .tags.svelte-1694xcs li:where(.svelte-1694xcs) {\n    font-size: 0.8rem;\n    background: var(--sage-soft);\n    color: var(--ink);\n    padding: 5px 13px;\n    border-radius: var(--radius-pill);\n  }\n\n  .reviews.svelte-1694xcs h2:where(.svelte-1694xcs) { font-size: 1.25rem; margin-bottom: 4px; }\n  .muted.svelte-1694xcs { color: var(--ink-faint); margin: 8px 0 0; }\n\n  .panel.svelte-1694xcs {\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n    padding: 20px;\n    position: sticky;\n    top: calc(var(--header-h) + 16px);\n  }\n  .panel.svelte-1694xcs h3:where(.svelte-1694xcs) { font-size: 1rem; margin-bottom: 10px; }\n  .map.svelte-1694xcs {\n    width: 100%;\n    aspect-ratio: 4 / 3;\n    border: 1px solid var(--line);\n    border-radius: calc(var(--radius) - 6px);\n    margin-bottom: 14px;\n  }\n  .addr.svelte-1694xcs { margin: 0 0 14px; line-height: 1.6; color: var(--ink-soft); font-size: 0.92rem; }\n  dl.svelte-1694xcs { margin: 0; display: grid; grid-template-columns: auto 1fr; gap: 8px 14px; font-size: 0.88rem; }\n  dt.svelte-1694xcs { color: var(--ink-faint); }\n  dd.svelte-1694xcs { margin: 0; }\n  dd.svelte-1694xcs a:where(.svelte-1694xcs) { color: var(--accent); font-weight: 500; }\n\n  .similar.svelte-1694xcs { margin-top: 48px; }\n  .similar.svelte-1694xcs h2:where(.svelte-1694xcs) { font-size: 1.3rem; margin-bottom: 16px; }\n  .grid.svelte-1694xcs { display: grid; grid-template-columns: repeat(auto-fill, minmax(230px, 1fr)); gap: 18px; }\n\n  @media (max-width: 880px) {\n    .columns.svelte-1694xcs { grid-template-columns: 1fr; }\n    .panel.svelte-1694xcs { position: static; }\n    .banner.svelte-1694xcs { aspect-ratio: 16 / 9; }\n  }\n\n  .gallery.svelte-1694xcs { margin: 28px 0; }\n  .gallery.svelte-1694xcs h2:where(.svelte-1694xcs) { font-size: 1.05rem; margin: 0 0 12px; }\n  .gallery.svelte-1694xcs .grid:where(.svelte-1694xcs) {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: 10px;\n  }\n  .shot.svelte-1694xcs {\n    position: relative;\n    padding: 0;\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n    overflow: hidden;\n    background: var(--card-soft);\n    cursor: zoom-in;\n    aspect-ratio: 4 / 3;\n  }\n  .shot.svelte-1694xcs img:where(.svelte-1694xcs) { width: 100%; height: 100%; object-fit: cover; display: block; }\n  .shot.svelte-1694xcs .credit:where(.svelte-1694xcs) {\n    position: absolute;\n    inset: auto 0 0 0;\n    padding: 3px 8px;\n    font-size: 0.7rem;\n    color: #fff;\n    background: linear-gradient(transparent, rgba(0, 0, 0, 0.62));\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .lightbox.svelte-1694xcs {\n    position: fixed;\n    inset: 0;\n    z-index: 200;\n    background: rgba(0, 0, 0, 0.86);\n    display: grid;\n    place-content: center;\n    gap: 12px;\n    padding: 28px;\n    cursor: zoom-out;\n  }\n  .lightbox.svelte-1694xcs img:where(.svelte-1694xcs) { max-width: min(94vw, 1100px); max-height: 80vh; object-fit: contain; border-radius: var(--radius); }\n  .lightbox-credit.svelte-1694xcs { color: #e7e3dc; font-size: 0.85rem; text-align: center; margin: 0; }\n  .lightbox-credit.svelte-1694xcs a:where(.svelte-1694xcs) { text-decoration: underline; color: #fff; }\n  .lightbox-credit.svelte-1694xcs .via:where(.svelte-1694xcs) { opacity: 0.65; margin-left: 8px; }\n  .lightbox.svelte-1694xcs .close:where(.svelte-1694xcs) {\n    position: fixed;\n    top: 16px;\n    right: 20px;\n    font-size: 2rem;\n    line-height: 1;\n    color: #fff;\n    background: none;\n    border: none;\n    cursor: pointer;\n  }\n\n  .elsewhere.svelte-1694xcs { margin: 34px 0 8px; }\n  .elsewhere.svelte-1694xcs h2:where(.svelte-1694xcs) { font-size: 1.05rem; margin: 0 0 12px; }\n  .source.svelte-1694xcs {\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n    background: var(--card);\n    padding: 16px 18px;\n    margin-bottom: 12px;\n  }\n  .source.svelte-1694xcs header:where(.svelte-1694xcs) {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    gap: 14px;\n    flex-wrap: wrap;\n    padding-bottom: 10px;\n    border-bottom: 1px solid var(--line);\n  }\n  .source.svelte-1694xcs header:where(.svelte-1694xcs) strong:where(.svelte-1694xcs) { font-size: 1.05rem; margin-right: 4px; }\n  .source.svelte-1694xcs header:where(.svelte-1694xcs) .stars:where(.svelte-1694xcs) { color: var(--accent); margin-right: 6px; letter-spacing: -1px; }\n  .source.svelte-1694xcs header:where(.svelte-1694xcs) a:where(.svelte-1694xcs) { font-size: 0.85rem; text-decoration: underline; white-space: nowrap; }\n\n  .source.svelte-1694xcs blockquote:where(.svelte-1694xcs) { margin: 12px 0 0; padding: 0 0 0 12px; border-left: 2px solid var(--line); }\n  .source.svelte-1694xcs blockquote:where(.svelte-1694xcs) p:where(.svelte-1694xcs) { margin: 0; font-size: 0.92rem; line-height: 1.55; }\n  .source.svelte-1694xcs blockquote:where(.svelte-1694xcs) footer:where(.svelte-1694xcs) {\n    margin-top: 5px;\n    font-size: 0.8rem;\n    color: var(--ink-soft);\n    display: flex;\n    gap: 8px;\n    align-items: baseline;\n    flex-wrap: wrap;\n  }\n  .source.svelte-1694xcs blockquote:where(.svelte-1694xcs) footer:where(.svelte-1694xcs) span:where(.svelte-1694xcs) { color: var(--accent); letter-spacing: -1px; }\n  .source.svelte-1694xcs blockquote:where(.svelte-1694xcs) cite:where(.svelte-1694xcs) { font-style: normal; font-weight: 600; }\n  .source.svelte-1694xcs blockquote:where(.svelte-1694xcs) footer:where(.svelte-1694xcs) a:where(.svelte-1694xcs) { text-decoration: underline; }\n\n  .asof.svelte-1694xcs { margin: 12px 0 0; font-size: 0.76rem; color: var(--ink-soft); }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function RestaurantDetail($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, RestaurantDetail);
	$.append_styles($$anchor, $$css);

	let detail = $.tag($.state(null), 'detail');
	let loading = $.tag($.state(true), 'loading');
	let missing = $.tag($.state(false), 'missing');
	let imageBroken = $.tag($.state(false), 'imageBroken');
	const slug = $.tag($.derived(() => route.params.slug), 'slug');

	$.user_effect(() => {
		const key = $.get(slug);

		if (!key) return;

		let cancelled = false;

		$.set(loading, true);
		$.set(missing, false);
		$.set(imageBroken, false);

		api.restaurant(key).then((response) => {
			if (cancelled) return;

			$.set(detail, response, true);
			rememberView(response.restaurant);
		}).catch(() => {
			if (!cancelled) $.set(missing, true);
		}).finally(() => {
			if (!cancelled) $.set(loading, false);
		});

		return () => {
			cancelled = true;
		};
	});

	function onReviewSaved(saved) {
		if (!$.get(detail)) return;

		const others = $.get(detail).reviews.filter((r) => $.strict_equals(r.id, saved.id, false));

		$.set(
			detail,
			{
				...$.get(detail),
				myReview: saved.userId ? saved : $.get(detail).myReview,
				reviews: [saved, ...others],
				restaurant: {
					...$.get(detail).restaurant,
					reviewCount: others.length + 1,
					ratingAverage: [saved, ...others].reduce((sum, r) => sum + r.rating, 0) / (others.length + 1)
				}
			},
			true
		);
	}

	async function removeReview(review) {
		try {
			(await $.track_reactivity_loss(api.deleteReview(review.id)))();

			const remaining = $.get(detail).reviews.filter((r) => $.strict_equals(r.id, review.id, false));

			$.set(
				detail,
				{
					...$.get(detail),
					reviews: remaining,
					myReview: $.strict_equals($.get(detail).myReview?.id, review.id) ? null : $.get(detail).myReview,
					restaurant: {
						...$.get(detail).restaurant,
						reviewCount: remaining.length,
						ratingAverage: remaining.length
							? remaining.reduce((sum, r) => sum + r.rating, 0) / remaining.length
							: 0
					}
				},
				true
			);
		} catch(error) {
			toastError(error.message ?? "Couldn't remove that review.");
		}
	}

	const r = $.tag($.derived(() => $.get(detail)?.restaurant), 'r');

	// Same blend RestaurantCard shows on the cards — the hero number here must not be the site's
	// own average alone, or a page and its own card would disagree about the restaurant's rating.
	const combined = $.tag(
		$.derived(() => $.get(r)?.combined ?? ($.get(r)?.reviewCount > 0
			? {
				rating: $.get(r).ratingAverage,
				ownCount: $.get(r).reviewCount,
				providerCount: 0
			}
			: null)),
		'combined'
	);

	const providerLabel = $.tag(
		$.derived(() => $.strict_equals($.get(combined)?.providerSource, "yelp")
			? "Yelp"
			: $.strict_equals($.get(combined)?.providerSource, "google") ? "Google" : "Google"),
		'providerLabel'
	);

	// Provider photos, flattened across sources and de-duplicated by URI — the same photo can come
	// back from more than one provider. The first is the hero; the rest fill the gallery.
	const photos = $.tag(
		$.derived(() => {
			const seen = new Set();
			const out = [];

			for (const source of $.get(detail)?.sources ?? []) {
				for (const photo of source.photos ?? []) {
					if (photo.uri && !seen.has(photo.uri)) {
						seen.add(photo.uri);
						out.push({ ...photo, source: source.source });
					}
				}
			}

			return out;
		}),
		'photos'
	);

	// An admin-uploaded image outranks the provider's; a person chose it.
	const hero = $.tag($.derived(() => $.get(r)?.thumbnailUrl || $.get(photos)[0]?.uri || null), 'hero');

	const gallery = $.tag($.derived(() => $.get(r)?.thumbnailUrl ? $.get(photos) : $.get(photos).slice(1)), 'gallery');
	let lightbox = $.tag($.state(null), 'lightbox');
	const SOURCE_LABELS = { google: "Google", yelp: "Yelp" };

	const mapsUrl = $.tag(
		$.derived(() => $.get(r)
			? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${$.get(r).name} ${$.get(r).address} ${$.get(r).city} ${$.get(r).state}`)}`
			: "#"),
		'mapsUrl'
	);

	// Keyless embed: precise pin from stored coordinates when we have them, otherwise the
	// address falls back to a text query. No Maps Embed API key needed for either form.
	const mapEmbedUrl = $.tag(
		$.derived(() => {
			if (!$.get(r)) return null;

			const q = $.get(r).latitude && $.get(r).longitude
				? `${$.get(r).latitude},${$.get(r).longitude}`
				: `${$.get(r).name} ${$.get(r).address} ${$.get(r).city} ${$.get(r).state}`;

			return `https://www.google.com/maps?q=${encodeURIComponent(q)}&output=embed`;
		}),
		'mapEmbedUrl'
	);

	var $$exports = { ...$.legacy_api() };
	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			$.add_svelte_meta(
				() => EmptyState($$anchor, {
					icon: '🚪',
					title: 'That place isn\'t listed',
					message: 'It may have closed, or the link might be off by a letter.',
					action: { href: "/", label: "Browse restaurants" }
				}),
				'component',
				RestaurantDetail,
				137,
				2,
				{ componentTag: 'EmptyState' }
			);
		};

		var consequent_1 = ($$anchor) => {
			var div = root();

			$.append($$anchor, div);
		};

		var consequent_21 = ($$anchor) => {
			var fragment_2 = root_23();
			var article = $.first_child(fragment_2);
			var div_1 = $.child(article);
			var node_1 = $.child(div_1);

			{
				var consequent_2 = ($$anchor) => {
					var img = root_1();

					$.template_effect(() => $.set_attribute(img, 'src', $.get(hero)));

					$.event('error', img, function error_1() {
						return $.set(imageBroken, true);
					});

					$.replay_events(img);
					$.append($$anchor, img);
				};

				var alternate = ($$anchor) => {
					var div_2 = root_2();
					var text = $.child(div_2, true);

					$.reset(div_2);
					$.template_effect(($0) => $.set_text(text, $0), [() => $.get(r).name.slice(0, 1)]);
					$.append($$anchor, div_2);
				};

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if ($.get(hero) && !$.get(imageBroken)) $$render(consequent_2); else $$render(alternate, -1);
					}),
					'if',
					RestaurantDetail,
					148,
					6
				);
			}

			$.reset(div_1);

			var header = $.sibling(div_1, 2);
			var div_3 = $.child(header);
			var p = $.child(div_3);
			var a = $.child(p);
			var text_1 = $.child(a, true);

			$.reset(a);

			var a_1 = $.sibling(a, 4);
			var text_2 = $.child(a_1, true);

			$.reset(a_1);
			$.reset(p);

			var h1 = $.sibling(p, 2);
			var text_3 = $.child(h1, true);

			$.reset(h1);

			var div_4 = $.sibling(h1, 2);
			var node_2 = $.child(div_4);

			{
				var consequent_5 = ($$anchor) => {
					var fragment_3 = root_3();
					var node_3 = $.first_child(fragment_3);

					$.add_svelte_meta(
						() => Stars(node_3, {
							get value() {
								return $.get(combined).rating;
							},
							count: null,
							size: 20
						}),
						'component',
						RestaurantDetail,
						165,
						12,
						{ componentTag: 'Stars' }
					);

					var span = $.sibling(node_3, 2);
					var node_4 = $.child(span);

					{
						var consequent_3 = ($$anchor) => {
							var text_4 = $.text();

							$.template_effect(($0) => $.set_text(text_4, `${$.get(combined).ownCount ?? ''} Upsorok + ${$0 ?? ''} ${$.get(providerLabel) ?? ''}`), [() => $.get(combined).providerCount.toLocaleString()]);
							$.append($$anchor, text_4);
						};

						var consequent_4 = ($$anchor) => {
							var text_5 = $.text();

							$.template_effect(() => $.set_text(text_5, `${$.get(combined).ownCount ?? ''} Upsorok review${$.strict_equals($.get(combined).ownCount, 1) ? "" : "s"}`));
							$.append($$anchor, text_5);
						};

						var alternate_1 = ($$anchor) => {
							var text_6 = $.text();

							$.template_effect(($0) => $.set_text(text_6, `${$0 ?? ''} ${$.get(providerLabel) ?? ''} review${$.strict_equals($.get(combined).providerCount, 1) ? "" : "s"}`), [() => $.get(combined).providerCount.toLocaleString()]);
							$.append($$anchor, text_6);
						};

						$.add_svelte_meta(
							() => $.if(node_4, ($$render) => {
								if ($.get(combined).ownCount > 0 && $.get(combined).providerCount > 0) $$render(consequent_3); else if ($.get(combined).ownCount > 0) $$render(consequent_4, 1); else $$render(alternate_1, -1);
							}),
							'if',
							RestaurantDetail,
							167,
							14
						);
					}

					$.reset(span);
					$.append($$anchor, fragment_3);
				};

				var alternate_2 = ($$anchor) => {
					var span_1 = root_4();

					$.append($$anchor, span_1);
				};

				$.add_svelte_meta(
					() => $.if(node_2, ($$render) => {
						if ($.get(combined)) $$render(consequent_5); else $$render(alternate_2, -1);
					}),
					'if',
					RestaurantDetail,
					164,
					10
				);
			}

			var span_2 = $.sibling(node_2, 2);
			var text_7 = $.child(span_2, true);

			$.reset(span_2);
			$.reset(div_4);
			$.reset(div_3);

			var div_5 = $.sibling(div_3, 2);
			var node_5 = $.child(div_5);

			$.add_svelte_meta(
				() => FavoriteButton(node_5, {
					get restaurant() {
						return $.get(r);
					},
					size: 26
				}),
				'component',
				RestaurantDetail,
				182,
				8,
				{ componentTag: 'FavoriteButton' }
			);

			var a_2 = $.sibling(node_5, 2);
			var node_6 = $.sibling(a_2, 2);

			{
				var consequent_6 = ($$anchor) => {
					var a_3 = root_5();

					$.template_effect(($0) => $.set_attribute(a_3, 'href', `tel:${$0 ?? ''}`), [() => $.get(r).phone.replace(/[^+\d]/g, '')]);
					$.append($$anchor, a_3);
				};

				$.add_svelte_meta(
					() => $.if(node_6, ($$render) => {
						if ($.get(r).phone) $$render(consequent_6);
					}),
					'if',
					RestaurantDetail,
					184,
					8
				);
			}

			$.reset(div_5);
			$.reset(header);

			var div_6 = $.sibling(header, 2);
			var div_7 = $.child(div_6);
			var node_7 = $.child(div_7);

			{
				var consequent_7 = ($$anchor) => {
					var p_1 = root_6();
					var text_8 = $.child(p_1, true);

					$.reset(p_1);
					$.template_effect(() => $.set_text(text_8, $.get(r).description));
					$.append($$anchor, p_1);
				};

				$.add_svelte_meta(
					() => $.if(node_7, ($$render) => {
						if ($.get(r).description) $$render(consequent_7);
					}),
					'if',
					RestaurantDetail,
					190,
					8
				);
			}

			var node_8 = $.sibling(node_7, 2);

			{
				var consequent_8 = ($$anchor) => {
					var ul = root_8();

					$.add_svelte_meta(
						() => $.each(ul, 20, () => $.get(r).tags, (tag) => tag, ($$anchor, tag) => {
							var li = root_7();
							var text_9 = $.child(li, true);

							$.reset(li);
							$.template_effect(() => $.set_text(text_9, tag));
							$.append($$anchor, li);
						}),
						'each',
						RestaurantDetail,
						194,
						12
					);

					$.reset(ul);
					$.append($$anchor, ul);
				};

				$.add_svelte_meta(
					() => $.if(node_8, ($$render) => {
						if ($.get(r).tags?.length) $$render(consequent_8);
					}),
					'if',
					RestaurantDetail,
					192,
					8
				);
			}

			var node_9 = $.sibling(node_8, 2);

			{
				var consequent_10 = ($$anchor) => {
					var section = root_11();
					var div_8 = $.sibling($.child(section), 2);

					$.add_svelte_meta(
						() => $.each(div_8, 21, () => $.get(gallery), (photo) => photo.uri, ($$anchor, photo) => {
							var button = root_10();
							var img_1 = $.child(button);
							var node_10 = $.sibling(img_1, 2);

							{
								var consequent_9 = ($$anchor) => {
									var span_3 = root_9();
									var text_10 = $.child(span_3, true);

									$.reset(span_3);
									$.template_effect(() => $.set_text(text_10, $.get(photo).attributionName));
									$.append($$anchor, span_3);
								};

								$.add_svelte_meta(
									() => $.if(node_10, ($$render) => {
										if ($.get(photo).attributionName) $$render(consequent_9);
									}),
									'if',
									RestaurantDetail,
									210,
									18
								);
							}

							$.reset(button);

							$.template_effect(() => {
								$.set_attribute(button, 'aria-label', $.get(photo).attributionName ? `Photo by ${$.get(photo).attributionName}` : "Photo");
								$.set_attribute(img_1, 'src', $.get(photo).uri);
							});

							$.delegated('click', button, function click() {
								return $.set(lightbox, $.get(photo), true);
							});

							$.append($$anchor, button);
						}),
						'each',
						RestaurantDetail,
						202,
						14
					);

					$.reset(div_8);
					$.reset(section);
					$.append($$anchor, section);
				};

				$.add_svelte_meta(
					() => $.if(node_9, ($$render) => {
						if ($.get(gallery).length > 0) $$render(consequent_10);
					}),
					'if',
					RestaurantDetail,
					198,
					8
				);
			}

			var section_1 = $.sibling(node_9, 2);
			var h2 = $.child(section_1);
			var text_11 = $.child(h2, true);

			$.reset(h2);

			var node_11 = $.sibling(h2, 2);

			{
				var consequent_11 = ($$anchor) => {
					var p_2 = root_12();

					$.append($$anchor, p_2);
				};

				var alternate_3 = ($$anchor) => {
					var fragment_7 = $.comment();
					var node_12 = $.first_child(fragment_7);

					$.add_svelte_meta(
						() => $.each(node_12, 17, () => $.get(detail).reviews, (review) => review.id, ($$anchor, review) => {
							{
								let $0 = $.derived(() => session.user && ($.strict_equals($.get(review).userId, session.user.id) || $.strict_equals(session.user.role, "admin")));

								$.add_svelte_meta(
									() => ReviewCard($$anchor, {
										get review() {
											return $.get(review);
										},

										get canDelete() {
											return $.get($0);
										},
										ondelete: removeReview
									}),
									'component',
									RestaurantDetail,
									226,
									14,
									{ componentTag: 'ReviewCard' }
								);
							}
						}),
						'each',
						RestaurantDetail,
						225,
						12
					);

					$.append($$anchor, fragment_7);
				};

				$.add_svelte_meta(
					() => $.if(node_11, ($$render) => {
						if ($.strict_equals($.get(detail).reviews.length, 0)) $$render(consequent_11); else $$render(alternate_3, -1);
					}),
					'if',
					RestaurantDetail,
					222,
					10
				);
			}

			$.reset(section_1);

			var node_13 = $.sibling(section_1, 2);

			$.add_svelte_meta(
				() => ReviewForm(node_13, {
					get slug() {
						return $.get(r).slug;
					},

					get existing() {
						return $.get(detail).myReview;
					},
					onsaved: onReviewSaved
				}),
				'component',
				RestaurantDetail,
				235,
				8,
				{ componentTag: 'ReviewForm' }
			);

			var node_14 = $.sibling(node_13, 2);

			{
				var consequent_12 = ($$anchor) => {
					var section_2 = root_15();
					var node_15 = $.sibling($.child(section_2), 2);

					$.add_svelte_meta(
						() => $.each(node_15, 17, () => $.get(detail).sources, (source) => source.source, ($$anchor, source) => {
							var article_1 = root_14();
							var header_1 = $.child(article_1);
							var div_9 = $.child(header_1);
							var span_4 = $.child(div_9);
							var text_12 = $.child(span_4, true);

							$.reset(span_4);

							var strong = $.sibling(span_4, 2);
							var text_13 = $.child(strong, true);

							$.reset(strong);

							var span_5 = $.sibling(strong, 2);
							var text_14 = $.child(span_5);

							$.reset(span_5);
							$.reset(div_9);

							var a_4 = $.sibling(div_9, 2);
							var text_15 = $.child(a_4);

							$.reset(a_4);
							$.reset(header_1);

							var node_16 = $.sibling(header_1, 2);

							$.add_svelte_meta(
								() => $.each(node_16, 17, () => $.get(source).excerpts, (excerpt) => excerpt.id, ($$anchor, excerpt) => {
									var blockquote = root_13();
									var p_3 = $.child(blockquote);
									var text_16 = $.child(p_3, true);

									$.reset(p_3);

									var footer = $.sibling(p_3, 2);
									var span_6 = $.child(footer);
									var text_17 = $.child(span_6, true);

									$.reset(span_6);

									var cite = $.sibling(span_6, 2);
									var text_18 = $.child(cite, true);

									$.reset(cite);

									var a_5 = $.sibling(cite, 2);
									var text_19 = $.child(a_5);

									$.reset(a_5);
									$.reset(footer);
									$.reset(blockquote);

									$.template_effect(
										($0) => {
											$.set_text(text_16, $.get(excerpt).body);
											$.set_text(text_17, $0);
											$.set_text(text_18, $.get(excerpt).authorName);
											$.set_attribute(a_5, 'href', $.get(excerpt).excerptUrl);
											$.set_text(text_19, `read on ${SOURCE_LABELS[$.get(source).source] ?? $.get(source).source ?? ''}`);
										},
										[() => ("★").repeat($.get(excerpt).rating)]
									);

									$.append($$anchor, blockquote);
								}),
								'each',
								RestaurantDetail,
								261,
								16
							);

							var p_4 = $.sibling(node_16, 2);
							var text_20 = $.child(p_4);

							$.reset(p_4);
							$.reset(article_1);

							$.template_effect(
								($0, $1, $2, $3) => {
									$.set_text(text_12, $0);
									$.set_text(text_13, $1);

									$.set_text(text_14, `${$2 ?? ''} review${$.strict_equals($.get(source).reviewCount, 1) ? "" : "s"}
                      on ${SOURCE_LABELS[$.get(source).source] ?? $.get(source).source ?? ''}`);

									$.set_attribute(a_4, 'href', $.get(source).sourceUrl);
									$.set_text(text_15, `View on ${SOURCE_LABELS[$.get(source).source] ?? $.get(source).source ?? ''} →`);
									$.set_text(text_20, `Snapshot taken ${$3 ?? ''}.`);
								},
								[
									() => ("★").repeat(Math.round($.get(source).rating)),
									() => $.get(source).rating.toFixed(1),
									() => $.get(source).reviewCount.toLocaleString(),
									() => relativeTime($.get(source).fetchedAt)
								]
							);

							$.append($$anchor, article_1);
						}),
						'each',
						RestaurantDetail,
						245,
						12
					);

					$.reset(section_2);
					$.append($$anchor, section_2);
				};

				$.add_svelte_meta(
					() => $.if(node_14, ($$render) => {
						if ($.get(detail).sources?.length) $$render(consequent_12);
					}),
					'if',
					RestaurantDetail,
					237,
					8
				);
			}

			$.reset(div_7);

			var aside = $.sibling(div_7, 2);
			var div_10 = $.child(aside);
			var node_17 = $.sibling($.child(div_10), 2);

			{
				var consequent_13 = ($$anchor) => {
					var iframe = root_16();

					$.template_effect(() => {
						$.set_attribute(iframe, 'src', $.get(mapEmbedUrl));
						$.set_attribute(iframe, 'title', `Map showing ${$.get(r).name ?? ''}`);
					});

					$.append($$anchor, iframe);
				};

				$.add_svelte_meta(
					() => $.if(node_17, ($$render) => {
						if ($.get(mapEmbedUrl)) $$render(consequent_13);
					}),
					'if',
					RestaurantDetail,
					282,
					10
				);
			}

			var p_5 = $.sibling(node_17, 2);
			var text_21 = $.child(p_5, true);
			var text_22 = $.sibling(text_21, 2);

			$.reset(p_5);

			var dl = $.sibling(p_5, 2);
			var node_18 = $.child(dl);

			{
				var consequent_14 = ($$anchor) => {
					var fragment_9 = root_17();
					var dd = $.sibling($.first_child(fragment_9));
					var text_23 = $.child(dd, true);

					$.reset(dd);
					$.template_effect(() => $.set_text(text_23, $.get(r).hours));
					$.append($$anchor, fragment_9);
				};

				$.add_svelte_meta(
					() => $.if(node_18, ($$render) => {
						if ($.get(r).hours) $$render(consequent_14);
					}),
					'if',
					RestaurantDetail,
					296,
					12
				);
			}

			var node_19 = $.sibling(node_18, 2);

			{
				var consequent_15 = ($$anchor) => {
					var fragment_10 = root_18();
					var dd_1 = $.sibling($.first_child(fragment_10));
					var a_6 = $.child(dd_1);
					var text_24 = $.child(a_6, true);

					$.reset(a_6);
					$.reset(dd_1);

					$.template_effect(
						($0) => {
							$.set_attribute(a_6, 'href', `tel:${$0 ?? ''}`);
							$.set_text(text_24, $.get(r).phone);
						},
						[() => $.get(r).phone.replace(/[^+\d]/g, '')]
					);

					$.append($$anchor, fragment_10);
				};

				$.add_svelte_meta(
					() => $.if(node_19, ($$render) => {
						if ($.get(r).phone) $$render(consequent_15);
					}),
					'if',
					RestaurantDetail,
					297,
					12
				);
			}

			var node_20 = $.sibling(node_19, 2);

			{
				var consequent_16 = ($$anchor) => {
					var fragment_11 = root_19();
					var dd_2 = $.sibling($.first_child(fragment_11));
					var a_7 = $.child(dd_2);

					$.reset(dd_2);
					$.template_effect(() => $.set_attribute(a_7, 'href', $.get(r).website));
					$.append($$anchor, fragment_11);
				};

				$.add_svelte_meta(
					() => $.if(node_20, ($$render) => {
						if ($.get(r).website) $$render(consequent_16);
					}),
					'if',
					RestaurantDetail,
					298,
					12
				);
			}

			var dd_3 = $.sibling(node_20, 3);
			var text_25 = $.child(dd_3, true);

			$.reset(dd_3);
			$.reset(dl);
			$.reset(div_10);
			$.reset(aside);
			$.reset(div_6);

			var node_21 = $.sibling(div_6, 2);

			{
				var consequent_17 = ($$anchor) => {
					var section_3 = root_20();
					var div_11 = $.sibling($.child(section_3), 2);

					$.add_svelte_meta(
						() => $.each(div_11, 21, () => $.get(detail).similar, (other) => other.id, ($$anchor, other) => {
							$.add_svelte_meta(
								() => RestaurantCard($$anchor, {
									get restaurant() {
										return $.get(other);
									},
									compact: true
								}),
								'component',
								RestaurantDetail,
								310,
								12,
								{ componentTag: 'RestaurantCard' }
							);
						}),
						'each',
						RestaurantDetail,
						309,
						10
					);

					$.reset(div_11);
					$.reset(section_3);
					$.append($$anchor, section_3);
				};

				$.add_svelte_meta(
					() => $.if(node_21, ($$render) => {
						if ($.get(detail).similar?.length) $$render(consequent_17);
					}),
					'if',
					RestaurantDetail,
					305,
					4
				);
			}

			$.reset(article);

			var node_22 = $.sibling(article, 2);

			{
				var consequent_20 = ($$anchor) => {
					var div_12 = root_22();
					var img_2 = $.child(div_12);
					var p_6 = $.sibling(img_2, 2);
					var node_23 = $.child(p_6);

					{
						var consequent_18 = ($$anchor) => {
							var fragment_13 = root_21();
							var a_8 = $.sibling($.first_child(fragment_13));
							var text_26 = $.child(a_8, true);

							$.reset(a_8);

							$.template_effect(() => {
								$.set_attribute(a_8, 'href', $.get(lightbox).attributionUri);
								$.set_text(text_26, $.get(lightbox).attributionName);
							});

							$.append($$anchor, fragment_13);
						};

						var consequent_19 = ($$anchor) => {
							var text_27 = $.text();

							$.template_effect(() => $.set_text(text_27, `Photo by ${$.get(lightbox).attributionName ?? ''}`));
							$.append($$anchor, text_27);
						};

						$.add_svelte_meta(
							() => $.if(node_23, ($$render) => {
								if ($.get(lightbox).attributionUri) $$render(consequent_18); else if ($.get(lightbox).attributionName) $$render(consequent_19, 1);
							}),
							'if',
							RestaurantDetail,
							329,
							8
						);
					}

					var span_7 = $.sibling(node_23, 2);
					var text_28 = $.child(span_7);

					$.reset(span_7);
					$.reset(p_6);

					var button_1 = $.sibling(p_6, 2);

					$.reset(div_12);

					$.template_effect(() => {
						$.set_attribute(img_2, 'src', $.get(lightbox).uri);
						$.set_text(text_28, `via ${$.get(lightbox).source ?? ''}`);
					});

					$.delegated('click', div_12, function click_1() {
						return $.set(lightbox, null);
					});

					$.delegated('keydown', div_12, function keydown(e) {
						return $.strict_equals(e.key, "Escape") && $.set(lightbox, null);
					});

					$.delegated('click', button_1, function click_2() {
						return $.set(lightbox, null);
					});

					$.append($$anchor, div_12);
				};

				$.add_svelte_meta(
					() => $.if(node_22, ($$render) => {
						if ($.get(lightbox)) $$render(consequent_20);
					}),
					'if',
					RestaurantDetail,
					317,
					2
				);
			}

			$.template_effect(
				($0, $1, $2, $3, $4, $5) => {
					$.set_attribute(a, 'href', $0);
					$.set_text(text_1, $.get(r).cuisine);
					$.set_attribute(a_1, 'href', $1);
					$.set_text(text_2, $2);
					$.set_text(text_3, $.get(r).name);
					$.set_text(text_7, $3);
					$.set_attribute(a_2, 'href', $.get(mapsUrl));

					$.set_text(text_11, $.strict_equals($.get(r).reviewCount, 0)
						? "No reviews yet"
						: `${$.get(r).reviewCount} neighbour${$.strict_equals($.get(r).reviewCount, 1) ? "" : "s"} weighed in`);

					$.set_text(text_21, $.get(r).address);
					$.set_text(text_22, ` ${$4 ?? ''} ${$.get(r).postalCode ?? ''}`);
					$.set_text(text_25, $5);
				},
				[
					() => searchUrl($.get(r).cuisine),
					() => searchUrl(`restaurants in ${$.get(r).city}`),
					() => formatLocation($.get(r)),
					() => priceLabel($.get(r).priceLevel),
					() => formatLocation($.get(r)),
					() => priceLabel($.get(r).priceLevel)
				]
			);

			$.append($$anchor, fragment_2);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.get(missing)) $$render(consequent); else if ($.get(loading) && !$.get(detail)) $$render(consequent_1, 1); else if ($.get(detail) && $.get(r)) $$render(consequent_21, 2);
			}),
			'if',
			RestaurantDetail,
			136,
			0
		);
	}

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click', 'keydown']);